<script>
	import { onMount } from "svelte";
	import { fadeIn, fadeInDown } from "@pernod-ricard-global-cms/jsanimations";
	export let siteName = "ck.com";
	onMount(() => {
		const header = document.querySelector(".site-header");
		const siteName = document.querySelector(".site-header__site-name");
		fadeInDown(header, 800).finished.then(() => fadeIn(siteName));
	});
</script>

<header id="site-header" class="site-header">
	<div id="header-contents" class="site-header__contents">
		<a class="site-header__site-name" href="https://ciarankamp.com">
			{siteName}
		</a>
	</div>
</header>

<style lang="scss">
	.site-header {
		z-index: 10;
		padding: 20px;
		@keyframes gradient {
			0% {
				background-position: 0% 50%;
			}
			50% {
				background-position: 100% 50%;
			}
			100% {
				background-position: 0% 50%;
			}
		}
		background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
		background-size: 400% 400%;
		animation: gradient 15s ease infinite;
		transform: translateY(-100%);
		&__site-name {
			color: white;
			font-weight: bold;
			opacity: 0;
		}
	}
</style>
